var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CModal',{staticClass:"p-shopNewsModal",attrs:{"dialog-id":"shopNews","show":_vm.show,"close-to":_vm.closeTo,"wysiwyg-content":false}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.informationData.title)+" ")]),_c('template',{slot:"content"},[_c('div',[_c('p',{staticClass:"p-shopNewsModal__date",domProps:{"textContent":_vm._s(
          _vm.$options.filters.dayjsFormat(
            _vm.informationData.publishedAt,
            _vm.$t('YYYY年M月D日.お知らせpublishedAt')
          )
        )}}),_c('p',{staticClass:"p-shopNewsModal__content",domProps:{"textContent":_vm._s(_vm.informationData.content)}})])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }